import styles from './clientsLoadingSkeleton.module.scss';

interface ClientsLoadingSkeletonProps {
  isEditorMode: boolean;
}

const collaboratorSections = ['designer', 'director', 'assistance'];

export const ClientsLoadingSkeleton = ({ isEditorMode }: ClientsLoadingSkeletonProps) => (
  <div
    className={styles.clientsLoadingSkeleton}
    data-testid='clients-loading-skeleton'
    aria-busy='true'
    aria-label='Loading project clients and collaborators'
  >
    <div className={styles.heading} aria-hidden='true' />

    <div className={styles.clientCard}>
      <div className={styles.clientPicture} aria-hidden='true' />
      <div className={styles.clientField} data-testid='client-field-skeleton' aria-hidden='true'>
        <span className={styles.label} />
        <span className={styles.value} />
      </div>
      <div className={styles.clientField} data-testid='client-field-skeleton' aria-hidden='true'>
        <span className={styles.label} />
        <span className={styles.value} />
      </div>
    </div>

    <div className={styles.collaborators}>
      {collaboratorSections.map((section) => (
        <section key={section} className={styles.collaboratorSection} data-testid='collaborator-section-skeleton'>
          <div className={styles.sectionHeading} aria-hidden='true' />
          <div className={styles.collaboratorRow}>
            <div className={styles.collaboratorField} data-testid='collaborator-field-skeleton' aria-hidden='true'>
              <span className={styles.label} />
              <span className={styles.value} />
            </div>
            <div className={styles.collaboratorField} data-testid='collaborator-field-skeleton' aria-hidden='true'>
              <span className={styles.label} />
              <span className={styles.value} />
            </div>
            <div className={styles.collaboratorField} data-testid='collaborator-field-skeleton' aria-hidden='true'>
              <span className={styles.label} />
              <span className={styles.value} />
            </div>
            {isEditorMode && <div className={styles.deleteField} aria-hidden='true' />}
          </div>
        </section>
      ))}
    </div>
  </div>
);
